"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncQueueManager = void 0;
class SyncQueueManager {
    constructor(httpAdapter) {
        this.httpAdapter = httpAdapter;
        this._syncQueueData = { items: [] };
    }
    get syncQueueData() {
        return this._syncQueueData;
    }
    fetchSyncQueue(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getSyncQueueAdapter()
                .getSyncQueue(params, context);
            if (!response.isAborted) {
                this._syncQueueData = { items: response.data };
            }
        });
    }
    approve(id, socDiscipline) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpAdapter
                .getSyncQueueAdapter()
                .approveSyncQueueItem(id, socDiscipline);
        });
    }
    reject(id, comment) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpAdapter
                .getSyncQueueAdapter()
                .rejectSyncQueueItem(id, comment);
        });
    }
}
exports.SyncQueueManager = SyncQueueManager;
